import { createReducer } from '@lib/plugin-redux-core';
import { RequestStatus } from '@lib/plugin-redux-core';
import { formCategoriesGlobalHandlers } from './form-categories-global.handler';
import { FormCategoriesGlobalState } from './form-categories-global.states';

const initialState: FormCategoriesGlobalState = {
  error: null,
  formCategiresWithAllOptions: [],
  getFormCategiresWithAllOptionsStatus: RequestStatus.RESET,
};

export const formCategoriesGlobalReducer = createReducer(initialState, [
  ...formCategoriesGlobalHandlers,
]);
